(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredient-faq-2"] && !Shopify.designMode) return;
  try {
    
  $(document).ready(function() {
    $('.dropdown-process').click(function(event) {

      event.preventDefault();
      $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
      $(this).parent().siblings('.details').slideToggle(400);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
